<div class="content-loading" *ngIf="isLoading()">
    <img src="assets/img/loading.gif" alt="web.general.label.loading"/>
</div>
